<script>
	var $ = require('jquery'),
		routeContext = require('core/routeContext');

	var HOST = 'd1lzx9fkb1m9tb.cloudfront.net';

	module.exports = {
		data: function () {
			return {
				documents: {
					pdf: null,
					docx: null,
					doc: null
				},
				linkText: null
			};
		},

		mounted() {
			var self = this,
				documentFieldIds = routeContext.pathname.replace('/modal/nojs/pdf/', '').split('/');

			documentFieldIds.forEach(function (id) {
				$.get('//' + HOST + '/doc-modals/' + id + '.json').then(function (result) {
					var extension, $markup, url;

					for (var i = 0; i < result.length; i++) {
						if (result[i].command === 'modal_display') {
							$markup = $('.filefield-file', result[i].output);

							break;
						} else if (result[i].command === 'settings') {
							var documentURL = result[i].settings.readworksPDF.url,
								tokens = documentURL.split('.');

							extension = tokens[tokens.length - 1];

							url = documentURL.replace('http://www.readworks.org', '//' + HOST);
						}
					}

					if (extension === 'pdf') {
						self.linkText = $markup.find('a').html();
					}

					$markup.find('a').each(function () {
						$(this).attr('href', url);
					});

					$markup.find('img').each(function () {
						$(this).attr('src', '//' + HOST + $(this).attr('src'));
					});

					self.documents[extension] = {
						markup: $markup.html(),
						url: url
					};
				});
			});
		},
		methods: {
			transformDrupalDocumentLink(value, linkText) {
				if (value && linkText) {
					var $el = $('<div>' + value + '</div>');

					$el.find('a').html(linkText);

					return $el.html();
				} else {
					return value;
				}
			}
		}
	};
</script>
<template>
	<main
		id="content"
		class="main DrupalModalHarness padding-medium font-small"
		role="main">
		<div
			v-for="extension in documents"
			v-if="extension"
			:key="extension.url"
			v-html="transformDrupalDocumentLink(extension.markup, linkText)"></div>
		<embed
			class="margin-top-medium"
			top-toolbar-height="56"
			v-if="documents.pdf"
			:src="documents.pdf.url" />
	</main>
</template>
<style lang="sass">
	@import 'config/colors';
	.route-drupal-document-harness {
		header,
		footer {
			display: none;
		}
	}

	.DrupalModalHarness {
		img {
			vertical-align: top;
		}
		embed {
			height: 100%;
			width: 97%;
			position: fixed;
			z-index: 1;
		}
	}
</style>
